import React, { forwardRef, type ReactElement } from 'react';
import { cn } from '@/lib/utils';

interface WrapperProperties extends React.ComponentPropsWithRef<'div'> {
  padding?: string;
  margin?: string;
  border?: string;
  shadow?: string;
  rounded?: string;
  background?: string;
  asChild?: boolean;
  children: ReactElement<{
    className?: string;
  }>;
}

// NOTE: Ref won't work with asChild
const Wrapper = forwardRef<HTMLDivElement, WrapperProperties>(
  (
    {
      padding = '',
      margin = '',
      border = '',
      shadow = '',
      rounded = '',
      background = '',
      asChild = false,
      className = '',
      children,
      ...props
    },
    ref,
  ) => {
    const wrapperClasses = cn(
      padding,
      margin,
      border,
      shadow,
      rounded,
      background,
      className,
    );

    if (asChild && React.isValidElement(children)) {
      return React.cloneElement(children, {
        ...props,
        className: cn(wrapperClasses, children.props.className ?? ''),
      });
    }

    return (
      <div ref={ref} className={wrapperClasses} {...props}>
        {children}
      </div>
    );
  },
);

Wrapper.displayName = 'Wrapper';

export default Wrapper;
